import { FC } from 'react';
import Login from './Login';

const LoginContainer: FC = () => {
  return <Login />;
};

export default LoginContainer;
